export default {
  RemoveCarExtra: 'Remove Car Extra',
  NewExtraCarAdd: 'New Extra Car Add',
  NewTariffAdd: 'New Tariff Add',
  RemoveTariff: 'Remove Tariff',
  ExtraCarUpdate: 'Extra Car Update',
  TariffUpdate: 'Tariff Update',
  RemoveItemExtra: 'Remove Item Extra',
  NewExtraEmployeeAdd: 'New Extra Employee Add',
  ExtraItemUpdate: 'Extra Item Update',

  Amount: 'Amount',
  FreeAmount: 'Free Amount',
  FreeAmountMin: 'FreeAmount Min',
  FreeAmountMax: 'FreeAmount Max',
  CarModel: 'Car Model',
  CompanyLogo: 'Courier Logo',
  CarOption: 'Car Option',
  Cost: 'Cost',
  CostMin: 'Cost Min',
  CostMax: 'Cost Max',
  CompanyName: 'Courier Name',
  Company: 'Courier',
  Count: 'Count',
  CostPerHourAdded: 'Cost Per Hour Added',
  DiscountPercent: 'Discount Percent',
  TimeService: 'Time Service',
  Tariff: 'Tariff',
  Enable: 'Enable',
  ExtraHourCost: 'Extra Hour Cost',
  ExtraCostMin: 'Extra Cost Min',
  ExtraCostMax: 'Extra Cost Max',
  ExtraKilometerCost: 'Extra Kilometer Cost',
  ExtraKilometerCostMin: 'Extra Kilometer Cost Min',
  ExtraKilometerCostMax: 'Extra Kilometer Cost Max',
  ExtraKilometerCommissionPercent: 'Extra Kilometer Commission Percent',
  Employee: 'Employee',
  Holiday: 'Holiday',
  Km: 'Km',
  LaborCost: 'Labor Costs',
  LaborerCostMin: 'Laborer Cost Min',
  LaborerCostMax: 'Laborer Cost Max',
  LaborerExtraHourCost: 'laborer Extra Hour Cost',
  LaborerExtraHourCostMin: 'Laborer ExtraHour Cost Min',
  LaborerExtraHourCostMax: 'Laborer ExtraHour Cost Max',
  Item: 'Item',
  Disable: 'Disable',
  Hour: 'Hour',
  PackSizeMin: 'PackSize Min',
  PackSizeMax: 'PackSize Max',
  serviceHourMin: 'service Hour Min',
  serviceHourMax: 'service Hour Max',
  ServiceKilometer: 'Kilometer Service',
  ServiceKilometerMin: 'Service kilometer min',
  ServiceKilometerMax: 'Service kilometer max'
}
